var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1630_3494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.08789 9.61499L16.0004 16.135L27.9129 9.61499",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16.1362V28.9962",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.48 22.8549L16.48 28.8774C16.3328 28.958 16.1678 29.0002 16 29.0002C15.8322 29.0002 15.6672 28.958 15.52 28.8774L4.52 22.8549C4.36293 22.769 4.23181 22.6425 4.14035 22.4885C4.04888 22.3346 4.00041 22.159 4 21.9799V10.0224C4.00041 9.84339 4.04888 9.66773 4.14035 9.51382C4.23181 9.3599 4.36293 9.23337 4.52 9.14743L15.52 3.12493C15.6672 3.0444 15.8322 3.0022 16 3.0022C16.1678 3.0022 16.3328 3.0444 16.48 3.12493L27.48 9.14743C27.6371 9.23337 27.7682 9.3599 27.8597 9.51382C27.9511 9.66773 27.9996 9.84339 28 10.0224V21.9774C28 22.1569 27.9518 22.3331 27.8603 22.4875C27.7688 22.6419 27.6374 22.7688 27.48 22.8549Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1953 6.03882L22.0003 12.5001V19.0001",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1630_3494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/Package.15c35788412a17bf545543c58c3e459d.svg";
export { ForwardRef as ReactComponent };